import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { XCircle } from 'lucide-react';

const PaymentCancel = () => {
  return (
    <Layout showFooter={false}>
      <div className="min-h-[calc(100vh-64px)] flex items-center justify-center px-4 bg-secondary" data-testid="payment-cancel-page">
        <Card className="w-full max-w-md">
          <CardContent className="p-8 text-center">
            <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
            <h1 className="font-serif text-2xl font-bold mb-2">Payment Cancelled</h1>
            <p className="text-muted-foreground mb-6">
              Your payment was cancelled. No charges were made.
            </p>
            <div className="space-y-2">
              <Button asChild className="w-full rounded-full">
                <Link to="/guest/dashboard">Return to Dashboard</Link>
              </Button>
              <Button asChild variant="outline" className="w-full rounded-full">
                <Link to="/weddings">Browse Weddings</Link>
              </Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
};

export default PaymentCancel;
